module.exports = __webpack_public_path__ + "img/1f63c.185cc89.svg";